import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, WHATSAPP_URL } from "./content";
import { scrollToId } from "./Reveal";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-3 sm:top-4 inset-x-3 sm:inset-x-6 z-50"
    >
      <nav className="mx-auto max-w-6xl flex items-center justify-between rounded-full bg-cream/80 backdrop-blur-xl border border-sage/15 pl-3 pr-2 py-2 shadow-[0_8px_30px_-12px_rgba(31,46,38,0.18)]">
        <button data-testid="nav-logo" onClick={() => go("inicio")} aria-label="Início"><Logo /></button>
        <div className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <button key={n.id} data-testid={`nav-link-${n.id}`} onClick={() => go(n.id)}
              className="px-4 py-2 rounded-full text-sm text-ink/80 hover:text-ink hover:bg-mint transition-colors">
              {n.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <a data-testid="nav-whatsapp-btn" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center rounded-full bg-sage text-cream text-sm px-5 py-2.5 hover:bg-ink transition-colors">
            Agendar conversa
          </a>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu"
            className="lg:hidden w-11 h-11 rounded-full bg-mint flex items-center justify-center text-ink">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="mobile-menu" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="lg:hidden mt-2 mx-auto max-w-6xl rounded-3xl bg-cream/95 backdrop-blur-xl border border-sage/15 p-4 flex flex-col">
            {NAV.map((n) => (
              <button key={n.id} data-testid={`mobile-nav-${n.id}`} onClick={() => go(n.id)}
                className="text-left font-display text-2xl text-ink py-2.5 border-b border-sage/10 last:border-0">
                {n.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
